import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { getDefaultLegalDocument } from '../data/legalDocuments';

export function useLegalDocument(documentId) {
  const [document, setDocument] = useState(() => getDefaultLegalDocument(documentId));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setDocument(getDefaultLegalDocument(documentId));
    setLoading(true);

    const unsubscribe = onSnapshot(
      doc(db, 'legalDocuments', documentId),
      (snapshot) => {
        const fallback = getDefaultLegalDocument(documentId);
        const data = snapshot.exists() ? snapshot.data() : {};
        setDocument({
          title: String(data.title || fallback.title),
          content: typeof data.content === 'string' ? data.content : fallback.content,
          fileUrl: typeof data.fileUrl === 'string'
            ? data.fileUrl
            : (typeof data.pdfUrl === 'string' ? data.pdfUrl : fallback.fileUrl),
          fileName: typeof data.fileName === 'string'
            ? data.fileName
            : (typeof data.pdfName === 'string' ? data.pdfName : fallback.fileName),
          fileType: typeof data.fileType === 'string'
            ? data.fileType
            : (data.pdfUrl ? 'pdf' : fallback.fileType),
        });
        setLoading(false);
      },
      () => {
        setDocument(getDefaultLegalDocument(documentId));
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [documentId]);

  return { document, loading };
}
